/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListAutoAction } from '../../models/api-response-list-auto-action';
import { AutoAction } from '../../models/auto-action';

export interface UpdateDefaultAction$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Array<AutoAction>
}

export function updateDefaultAction(http: HttpClient, rootUrl: string, params: UpdateDefaultAction$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAutoAction>> {
  const rb = new RequestBuilder(rootUrl, updateDefaultAction.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListAutoAction>;
    })
  );
}

updateDefaultAction.PATH = '/v1/api/ui/auto-actions/';
